// @flow
/** @jsx h */
import { h } from 'preact';
import Button from 'preact-material-components/Button';
import { styled } from 'goober';
import Loader from './Loader';

type CustomButtonProps = {
  name: string,
  id: string,
  onClick: Function,
  track?: Function,
  disable?: boolean,
  loading?: boolean,
  style?: { [key: string]: any },
  className?: string,
  containerClass?: string,
};

const CustomButtonContainer = styled('div')`
  text-align: center;

  .buttonStyle {
    background-color: var(--primaryCTAColor) !important;
    width: 100% !important;
    height: 50px !important;
    color: white !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    margin: 0px auto !important;
    cursor: pointer !important;
    border: 0px !important;
    border-radius: 8px !important;
    text-transform: none !important;
    max-width: 320px;
    letter-spacing: 0.1px;
  }
  .buttonStyle:disabled {
    font-weight: 500 !important;
    color: #636363 !important;
    background: #d9d9d9 !important;
    letter-spacing: 0.1px;
  }
`;

export default function CustomButton(props: CustomButtonProps) {
  const {
    name,
    id,
    disable,
    onClick,
    track,
    loading,
    style = {},
    className,
    containerClass,
  } = props;
  return (
    <CustomButtonContainer className={containerClass}>
      <Button
        type='submit'
        disabled={disable}
        className={`buttonStyle ${className ? className : ''}`}
        id={id}
        name={name}
        onClick={
          loading
            ? () => {}
            : (e) => {
                if (onClick) onClick(e);
                if (track) track(e);
              }
        }
        style={{
          textTransform: 'none',
          ...style,
        }}>
        {!!loading ? (
          <Loader applyOpacity={false} backgroundColor='#ffffff' />
        ) : (
          name
        )}
      </Button>
    </CustomButtonContainer>
  );
}



// WEBPACK FOOTER //
// ./components/checkoutWidget/CustomButton.js